import { render, staticRenderFns } from "./sideMenu.vue?vue&type=template&id=0446fb42&scoped=true"
import script from "./sideMenu.vue?vue&type=script&lang=js"
export * from "./sideMenu.vue?vue&type=script&lang=js"
import style0 from "./sideMenu.vue?vue&type=style&index=0&id=0446fb42&prod&lang=scss&scoped=true"
import style1 from "./sideMenu.vue?vue&type=style&index=1&id=0446fb42&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0446fb42",
  null
  
)

export default component.exports